import { TabsList } from "@radix-ui/react-tabs";
import { styled } from "@vitality-ds/system";
import BaseTabsListStyles from "./styles/BaseTabsList.styles";
import BaseTabsListContainerStyles from "./styles/BaseTabsListContainer.styles";
export var BaseTabsList = styled(TabsList, BaseTabsListStyles);
export var BaseTabsListContainer = styled("div", BaseTabsListContainerStyles);